export default "__VITE_ASSET__BqA9KB65__"